import learningApi from '@src/services/api/learning/index'

export default learningApi.defineApi([
  // 決済上限下限取得
  {
    name: 'getMastersPaymentMethod',
    method: 'get',
    url: '/masters/payment/method'
  }
])
